var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.loaded
    ? _c("ls-report-grid", {
        class: _vm.className,
        attrs: {
          "api-root": _setup.apiRoot,
          jwt: _setup.jwt,
          "verification-token": _setup.verificationToken,
          domain: _setup.domain,
          "enable-record-type": "",
          "enable-limits": "",
          "enable-pivots": "",
          "enable-migrations": "",
          "enable-lookups": "",
          "enable-header-edit": "",
          "enable-carves": "",
          "enable-floating-filters": "",
        },
        domProps: {
          rootDomainId: _vm.domainId,
          viewId: _setup.defaultView,
          autoLoad: _vm.autoLoad,
          enableRefresh: true,
          enableExport: true,
          enableClearFilters: true,
          enableFilters: _vm.filters,
          enableGrouping: _vm.groups,
          enableView: _vm.views,
          enableStrats: _vm.strats,
          enableValidations: _vm.validations,
          enableLoanStatus: _vm.partitions,
          enableDomainSets: _vm.sets,
          enableSetCreation: _vm.sets,
          enableTime: _vm.asOfDate,
          enableExportToExcel: _vm.exportToExcel,
          enableCutCopyPaste: _vm.cutCopyPaste,
          enableExpand: _vm.expand,
          enableSummary: _vm.summaryMode,
          enableDataAlternate: _vm.dataAlternates,
          enableSubdomainFilters: _vm.subdomainBox,
          enableCreate: _setup.canEdit,
          enableEdit: _setup.canEdit,
          enableDelete: _setup.canEdit,
          enableSave: _setup.canEdit,
          enableSavingReport: _setup.canEdit,
          enableCheckboxRowSelection: _vm.sets,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }